import React, { useEffect, useState } from 'react';

const GridLayout = ({ children, gridClassName }) => {
  const childrenArray = React.Children.toArray(children);
  const [currentColumns, setCurrentColumns] = useState(2);

  const getColumnConfigs = (className) => {
    const columnMatches = {
      'grid-cols-2': 2,
      'grid-cols-3': 3,
      'grid-cols-4': 4,
      'grid-cols-5': 5,
      'grid-cols-6': 6,
      'md:grid-cols-2': 2,
      'md:grid-cols-3': 3,
      'md:grid-cols-4': 4,
      'md:grid-cols-5': 5,
      'md:grid-cols-6': 6,
      'lg:grid-cols-2': 2,
      'lg:grid-cols-3': 3,
      'lg:grid-cols-4': 4,
      'lg:grid-cols-5': 5,
      'lg:grid-cols-6': 6,
      'xl:grid-cols-6': 6,
    };

    const classes = className.split(' ');
    const configs = {
      base: 2,
      md: null,
      lg: null
    };

    classes.forEach(cls => {
      if (columnMatches[cls]) {
        if (cls.startsWith('lg:')) {
          configs.lg = columnMatches[cls];
        } else if (cls.startsWith('md:')) {
          configs.md = columnMatches[cls];
        } else {
          configs.base = columnMatches[cls];
        }
      }
    });

    return configs;
  };

  useEffect(() => {
    const updateColumns = () => {
      const configs = getColumnConfigs(gridClassName);
      const width = window.innerWidth;

      if (width >= 1024 && configs.lg) {
        setCurrentColumns(configs.lg);
      } else if (width >= 768 && configs.md) {
        setCurrentColumns(configs.md);
      } else {
        setCurrentColumns(configs.base);
      }
    };

    updateColumns();
    window.addEventListener('resize', updateColumns);
    return () => window.removeEventListener('resize', updateColumns);
  }, [gridClassName]);

  if (!childrenArray.length || !currentColumns) {
    return null;
  }

  const rows = [];
  for (let i = 0; i < childrenArray.length; i += currentColumns) {
    rows.push(childrenArray.slice(i, i + currentColumns));
  }

  return (
    <div className="w-full">
      {rows.map((rowItems, rowIndex) => {
        const isLastRow = rowIndex === rows.length - 1;
        const shouldCenter = isLastRow && rowItems.length < currentColumns;

        if (!shouldCenter) {
          return (
            <div key={rowIndex} className={`grid gap-4 ${gridClassName}`}>
              {rowItems.map((child, index) => (
                <div key={index}>{child}</div>
              ))}
            </div>
          );
        }


        const gapSize = 16;
        const totalGapWidth = (currentColumns - 1) * gapSize;
        const itemWidthPx = `calc((100% - ${totalGapWidth}px) / ${currentColumns})`;

        return (
          <div key={rowIndex} className="flex justify-center gap-4 w-full">
            {rowItems.map((child, index) => (
              <div
                key={index}
                style={{
                  width: itemWidthPx,
                  maxWidth: itemWidthPx
                }}
              >
                {child}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default GridLayout; 